import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Button } from '../ui/button';
import { Bell, Building2 } from 'lucide-react';
import { MobileMenuButton } from './Sidebar';
import NivaAvatar from '../NivaAvatar';

const Header = ({ user, onOpenMobileMenu }) => {
  const navigate = useNavigate();
  const organizationName = user?.organization?.name || user?.organization?.companyName || 'Organization';
  const userRole = user?.role || 'member';
  const roleDisplay = userRole.charAt(0).toUpperCase() + userRole.slice(1);

  // Prefer full name; fall back to username
  const displayName = user?.name?.trim() || user?.username || 'User';
  const initials = displayName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

  return (
    <header className="flex h-16 items-center gap-4 border-b bg-gradient-to-r from-cyan-50 to-blue-50 px-4 md:px-6 shadow-sm dark:from-gray-900 dark:to-gray-800">
      <MobileMenuButton onClick={onOpenMobileMenu} />
      <div className="flex items-center gap-3 mr-4">
        <div className="flex items-center justify-center h-10 w-10 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 shadow-md">
          <Building2 className="h-5 w-5 text-white" />
        </div>
        <div className="flex flex-col">
          <span className="text-sm font-bold text-gray-900 dark:text-gray-100">
            {organizationName}
          </span>
          <span className="text-xs text-cyan-600 dark:text-cyan-400 font-medium">
            {roleDisplay}
          </span>
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <button
          onClick={() => navigate('/niva')}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-gray-200 shadow-sm hover:shadow-md hover:border-cyan-300 transition-all text-sm text-gray-500 hover:text-cyan-600 group w-48 md:w-64"
        >
          <NivaAvatar size="xs" />
          <span className="flex-1 text-left truncate">Ask Niva...</span>
        </button>
      </div>
      <Button variant="ghost" size="icon" className="rounded-full hover:bg-white/50">
        <Bell className="h-4 w-4" />
        <span className="sr-only">Toggle notifications</span>
      </Button>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium hidden md:block text-gray-900 dark:text-gray-100">
          {displayName}
        </span>
        <Avatar className="border-2 border-white shadow-sm">
          <AvatarImage src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${displayName}`} />
          <AvatarFallback>{initials || 'US'}</AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
};

export default Header;